module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/th/6-cca2324af37b4c5e50562c2cbe90b86c.jpg";